import { createFileRoute, redirect } from "@tanstack/react-router";
import { Grid } from "@/components/app/grid";
import { authStore } from "../../lib/stores/auth-store";

const AUTH_CHECK_INTERVAL_MS = 100;

export const Route = createFileRoute("/app/")({
	beforeLoad: async () => {
		while (!authStore.getState().initialized) {
			await new Promise((resolve) =>
				setTimeout(resolve, AUTH_CHECK_INTERVAL_MS)
			);
		}

		const { user } = authStore.getState();
		if (!user) {
			throw redirect({
				to: "/",
				search: {
					redirect: "/app",
				},
			});
		}
	},
	component: RouteComponent,
});

function RouteComponent() {
	return <Grid />;
}
